// =============================================================================
// FILE:
// frontend/src/ipe/pms/components/site_store_dashboard/SiteStoreIssueHistorySection.jsx
// =============================================================================

import React, {
  useEffect,
  useState
} from "react";

import {
  Package
} from "lucide-react";

import {
  getMaterialIssueList
} from "../../services/siteStoreExecutionService";

import executionStyles
  from "./siteStoreExecutionStyles";


// =============================================================================
// COMPONENT
// =============================================================================

export default function SiteStoreIssueHistorySection({

  row

}) {

  // ===========================================================================
  // STATE
  // ===========================================================================

  const [loading, setLoading] =
    useState(false);

  const [issueRows, setIssueRows] =
    useState([]);

  const [error, setError] =
    useState("");


  // ===========================================================================
  // LOAD ISSUE HISTORY
  // ===========================================================================

  const loadIssueHistory =
    async () => {

      try {

        setLoading(true);

        setError("");

        const response =
          await getMaterialIssueList({

            page: 1,

            page_size: 500
          });

        const allRows =
          response?.data || [];

        console.log(
          "ISSUE ROWS",
          allRows
        );

        console.log(
          "CURRENT DRAWER ROW",
          row
        );

        // ==============================================================
        // FILTER MATCHING EXECUTION RECORDS
        // ==============================================================

        const filteredRows =
          allRows.filter((item) => {

            return (
              String(
                item.task_material_plan_id
              ) ===
              String(
                row.task_material_plan_id
              )
            );
          });

        setIssueRows(
          filteredRows
        );

      } catch (err) {

        console.error(err);

        setError(

          err?.response?.data?.message ||

          "Failed to load issue history"
        );

      } finally {

        setLoading(false);
      }
    };


  // ===========================================================================
  // LOAD ON OPEN
  // ===========================================================================

  useEffect(() => {

    if (row) {

      loadIssueHistory();
    }

  }, [row]);


  // ===========================================================================
  // RENDER
  // ===========================================================================

  return (

    <div style={executionStyles.section}>


      {/* ================================================================ */}
      {/* TITLE */}
      {/* ================================================================ */}

      <div style={executionStyles.sectionTitle}>

        Material Issue History

      </div>


      {/* ================================================================ */}
      {/* LOADING */}
      {/* ================================================================ */}

      {
        loading && (

          <div style={executionStyles.loadingBox}>

            Loading issue history...

          </div>
        )
      }


      {/* ================================================================ */}
      {/* ERROR */}
      {/* ================================================================ */}

      {
        error && (

          <div style={executionStyles.errorBox}>

            {error}

          </div>
        )
      }


      {/* ================================================================ */}
      {/* EMPTY */}
      {/* ================================================================ */}

      {
        !loading &&
        !error &&
        issueRows.length === 0 && (

          <div style={executionStyles.emptyBox}>


            <Package
              size={40}
              style={{
                marginBottom: 12,
                color: "#9ca3af"
              }}
            />

            <div>

              No issue history found

            </div>

          </div>
        )
      }


      {/* ================================================================ */}
      {/* TABLE */}
      {/* ================================================================ */}

      {
        !loading &&
        issueRows.length > 0 && (

          <div style={executionStyles.tableWrap}>


            <table style={executionStyles.table}>


              <thead>

                <tr>

                  <th style={executionStyles.th}>
                    Issue No
                  </th>

                  <th style={executionStyles.th}>
                    Issue Date
                  </th>

                  <th style={executionStyles.th}>
                    Warehouse Movement
                  </th>

                  <th style={executionStyles.th}>
                    Status
                  </th>

                  <th
                    style={{
                      ...executionStyles.th,
                      textAlign: "right"
                    }}
                  >
                    Issued Qty
                  </th>

                </tr>

              </thead>


              <tbody>

                {
                  issueRows.map((item) => (

                    <tr key={item.id}>


                      <td style={executionStyles.td}>

                        {item.issue_no || "-"}

                      </td>


                      <td style={executionStyles.td}>

                        {item.issue_date || "-"}

                      </td>


                      <td style={executionStyles.td}>

                        {
                          item.warehouse_movement_header_id || "-"
                        }

                      </td>


                      <td style={executionStyles.td}>


                        <span
                          style={
                            executionStyles.statusIssued
                          }
                        >

                          {
                            item.issue_status || "ISSUED"
                          }

                        </span>

                      </td>


                      <td style={executionStyles.tdRight}>

                        {
                          item.issued_qty || 0
                        }

                      </td>

                    </tr>
                  ))
                }

              </tbody>

            </table>

          </div>
        )
      }

    </div>
  );
}